<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Languages')">
      <b-form-group
          :label="$t('message.Name_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="language.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="language.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="language.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="language.name_kz"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addLanguages, editLanguage, getLanguageById} from "../../../../../../api/languages";

export default {
  name: "langModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      language: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchLanguages(){
      getLanguageById({ id: this.id}).then(response => {
        this.language = response.data.data
      })
    },
    handleSubmit() {
      if (this.language.name_uz
          && this.language.name_ru
          && this.language.name_en
          && this.language.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editLanguage(this.language).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addLanguages(this.language).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchLanguages()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




